module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-weapon4.png?dbebfc8f";